import get from 'lodash/get'
import request from '../request'
import { createAuthorization } from '../auth'

/**
 * Get merchandising campaigns from brooklyn
 */
export async function getTitles ({
  auth, server, value, type, bundle, pp = 7,
}) {
  const params = {
    title: value,
    pp,
    contentType: type,
    bundle,
  }
  const res = await request
    .get(`${server}/s/admin/node_autocomplete`)
    .query(params)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', {})
}
